import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import mutator from 'mutator';

export default graphql(
  gql`
    mutation DeleteReader($input: Int!) {
      deleteReader(id: $input)
    }
  `,
  {
    props: ({ mutate }) => ({
      deleteReader: async (input) => {
        return mutator(() =>
          mutate({
            variables: { input },
          })
        );
      },
    }),
  }
);
